import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { GoogleReviewStatusInterface } from '../exports/Interfaces';

class PromotionManager {
  public async getGoogleReviewStatus(companyId: number): Promise<DataWrappedResponse<GoogleReviewStatusInterface>> {
    if (typeof companyId !== 'number') {
      return {
        response: null,
        success: false,
        status: 400,
      };
    }

    return BackendApiClient.requestAuthorized({
      method: 'GET',
      url: `/companies/${companyId}/last-google-review`,
    });
  }

  public async uploadGoogleReview(
    companyId: number,
    data: FormData,
    onUploadProgress: (progressPercentage: number) => void,
  ) {
    return BackendApiClient.requestAuthorized({
      method: 'POST',
      url: `/companies/${companyId}/google-reviews`,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onUploadProgress(percentCompleted);
      },
    });
  }
}

export default new PromotionManager();
